import { List, ListItem, ListItemText } from '@material-ui/core';
import useInterceptionObserver from 'hooks/useInterceptionObserver';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import useDebounce from 'hooks/useDebounce';
// const SLayout = styled.div``;

const SDrawerLayout = styled.div`
    width: 270px;
    background: #f6f6f6;
    flex-shrink: 0;
    position: relative;
`;

const SDrawerFooterLayout = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
`

const Navigation = ({ listOfSections, footer = null }) => {
    const [currentSection, setCurrentSection] = useState(listOfSections[0].text);

    const navigatedSection = useInterceptionObserver({
        elements: listOfSections.map((item) => ({ id: item.className, text: item.text })),
    });

    const debouncedTitle = useDebounce(navigatedSection);
    useEffect(() => {
        setCurrentSection(debouncedTitle);
    }, [debouncedTitle]);

    return (
        <SDrawerLayout>
            <List component="nav">
                {listOfSections.map((item, index) => {
                    return (
                        <ListItem
                            onClick={(e) => {
                                setCurrentSection(item.text);
                                listOfSections[index].ref.current.scrollIntoView({
                                    behavior: 'smooth',
                                });
                            }}
                            selected={item.text === currentSection}
                            key={item.text}
                            button
                            dense
                        >
                            <ListItemText primary={item.text} />
                        </ListItem>
                    );
                })}
            </List>
            <SDrawerFooterLayout>
                {!!footer && footer}
            </SDrawerFooterLayout>
        </SDrawerLayout>
    );
};

export default Navigation;
